import { format } from 'date-fns'
import { Currency } from 'utilities/currency'

export const APP_NAME = 'FNZ Q-Hub'
export const CURRENCY: Currency = 'ZAR'
export const SESSION_TIMEOUT = 20 * 60 * 1000 // 20 minutes
export const TENANT = 'absa'
export const SUPPORT_EMAIL_ADDRESS = 'ETPManagers@absa.africa'

export const NOTE_NAME_MAX_LENGTH = 64
export const TRADE_NAME_MAX_LENGTH = 64

export const TODAY = new Date()

type ReportingNoteTabs =
  | 'details'
  | 'trades'
  | 'statements'
  | 'trade-confirmations'
  | 'documents'
  | 'top-up-withdraw'
  | 'transfer'
  | 'close'

type NoteApprovalTabs = 'activation' | 'top-up-withdraw' | 'details'
type NoteActivationTabs = '' | 'approve' | 'commitment' | 'settlement' | 'activate'

export const PATH = {
  home: '/',
  login: '/login',
  logout: '/logout',
  twoFactor: '/two-factor',
  confirmAccount: '/confirm-account/:userId/:username/:token',
  resetPasswordRequest: '/reset-password/request',
  resetPasswordSent: '/reset-password/success',
  resetPassword: '/reset-password/:userId/:token',
  notFound: '/not-found',
  permissionsRequired: '/permissions-required',
  accountInactive: '/account-inactive',
  accountLocked: '/account-locked',
  twoFactorNotSetUp: '/set-up-two-factor',
  changePassword: '/change-password',
  reportsOverview: '/reports/overview',
  reportsNotes: '/reports/notes',
  reportsSingleNote: (noteId: string, tab: ReportingNoteTabs) => `/reports/notes/${noteId}/${tab}`,
  reportsTrades: '/reports/trades',
  reportsSingleTradePerformance: (source: string, tradeId: string) =>
    `/reports/trades/${source}/${tradeId}/performance`,
  reportsSingleTradeEventsHoldings: (source: string, tradeId: string, date: Date) =>
    `/reports/trades/${source}/${tradeId}/events/${format(date, 'yyyy-MM-dd')}/holdings`,
  reportsSingleTradeEventsParameters: (source: string, tradeId: string, date: Date) =>
    `/reports/trades/${source}/${tradeId}/events/${format(date, 'yyyy-MM-dd')}/parameters`,
  reportsSingleTradeEventsEvent: (
    source: string,
    tradeId: string,
    date: Date,
    operationId: string
  ) =>
    `/reports/trades/${source}/${tradeId}/events/${format(
      date,
      'yyyy-MM-dd'
    )}/events/${operationId}`,
  reportsSingleTradeDetailsNote: (source: string, tradeId: string) =>
    `/reports/trades/${source}/${tradeId}/details/note`,
  reportsSingleTradeDetailsTerms: (source: string, tradeId: string) =>
    `/reports/trades/${source}/${tradeId}/details/terms`,
  reportsSingleTradeDetailsPortfolioOverview: (source: string, tradeId: string) =>
    `/reports/trades/${source}/${tradeId}/details/portfolio/overview`,
  reportsSingleTradeDetailsPortfolioBreakdown: (source: string, tradeId: string) =>
    `/reports/trades/${source}/${tradeId}/details/portfolio/breakdown`,
  reportsSingleTradeDetailsStrategy: (source: string, tradeId: string) =>
    `/reports/trades/${source}/${tradeId}/details/strategy`,
  reportsSingleTradeFeesRates: (source: string, tradeId: string) =>
    `/reports/trades/${source}/${tradeId}/fees/rates`,
  reportsSingleTradeFeesBreakdownTotal: (source: string, tradeId: string) =>
    `/reports/trades/${source}/${tradeId}/fees/breakdown/total`,
  reportsSingleTradeFeesBreakdownDeductions: (source: string, tradeId: string) =>
    `/reports/trades/${source}/${tradeId}/fees/breakdown/deductions`,
  reportsSingleTradeFeesHistory: (source: string, tradeId: string) =>
    `/reports/trades/${source}/${tradeId}/fees/history`,
  reportsSingleTradeHistoryAndDocuments: (source: string, tradeId: string) =>
    `/reports/trades/${source}/${tradeId}/history-documents`,
  reportsSingleTradeTradeRiskDetails: (source: string, tradeId: string) =>
    `/reports/trades/${source}/${tradeId}/trade-risk/details`,
  reportsSingleTradeTradeRiskPortfolio: (source: string, tradeId: string) =>
    `/reports/trades/${source}/${tradeId}/trade-risk/portfolio`,
  reportsSingleTradeClose: (source: string, tradeId: string) =>
    `/reports/trades/${source}/${tradeId}/close`,
  productAdminAssets: '/product-admin/assets',
  productAdminPortfolios: '/product-admin/portfolios',
  productAdminStrategies: '/product-admin/strategies',
  productAdminDepositInstruments: '/product-admin/deposit-instruments',
  productAdminLoanInstruments: '/product-admin/loan-instruments',
  tradeBuilderExisting: (tradeId: string) => `/trades/build/${tradeId}`,
  tradeBuilderEdit: (tradeId: string) => `/trades/edit/${tradeId}`,
  tradeBuilderClose: (tradeId: string) => `/trades/close/${tradeId}`,
  tradeBuilderCloseAll: (tradeId: string) => `/trades/closeall/${tradeId}`,
  tradeBuilderNew: '/trades/build',
  trades: '/trades',
  noteApprovals: `/note-approvals`,
  noteApprovalsSingleNote: (
    noteId: string,
    tab: NoteApprovalTabs,
    activationTab: NoteActivationTabs = ''
  ) => `/note-approvals/${noteId}/${tab}/${activationTab}`,
  usersClients: '/users/clients',
  usersAbsa: '/users/absa',
  portfolioManagers: '/users/portfolio-managers',
  backOfficeFunds: '/back-office/funds',
  backOfficeOrders: '/back-office/orders',
  backOfficeReconciliation: '/back-office/reconciliation',
  backOfficeTaxReports: '/back-office/tax-reports',
  backOfficeUnitTransfers: '/back-office/unit-transfers',
  gapRisk: '/gap-risk'
}
